import { render } from "./SectionLiquidationForm.vue?vue&type=template&id=36e21c6a&scoped=true"
import script from "./SectionLiquidationForm.vue?vue&type=script&lang=js"
export * from "./SectionLiquidationForm.vue?vue&type=script&lang=js"

import "./SectionLiquidationForm.vue?vue&type=style&index=0&id=36e21c6a&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e21c6a"]])

export default __exports__